<template>
    <div class="case-nav">
        <button class="case-arrow" aria-label="Назад" @click="$emit('prev')">
            <v-icon size="20">mdi-chevron-left</v-icon>
        </button>
        <div class="case-dots">
            <button
                v-for="index in pageIndexes"
                :key="reviewMode ? 'review-' + index : index"
                type="button"
                class="case-dot"
                :class="{ on: index === currentPage }"
                :aria-label="(reviewMode ? 'Страница отзывов ' : 'Страница кейсов ') + (index + 1)"
                @click="$emit('go-to', index)"
            ></button>
        </div>
        <button class="case-arrow" aria-label="Вперёд" @click="$emit('next')">
            <v-icon size="20">mdi-chevron-right</v-icon>
        </button>
    </div>
</template>

<script>
export default {
    name: 'StarterPackCarouselNav',
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        pageIndexes: {
            type: Array,
            required: true,
        },
        reviewMode: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.case-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
}

.case-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    color: #2e8b57;
    background: #fff;
    border: 1px solid #cbe5d5;
    border-radius: 50%;
    cursor: pointer;
    font-size: 18px;
}

.case-dots {
    display: flex;
    align-items: center;
    gap: 6px;
}

.case-dot {
    width: 7px;
    height: 7px;
    padding: 0;
    background: #cbe5d5;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    transition: width 0.2s ease, background 0.2s ease, border-radius 0.2s ease;

    &.on {
        width: 18px;
        background: #2e8b57;
        border-radius: 4px;
    }
}
</style>
